import { CSSProperties, ReactNode } from "react";
import Styles from "./NSModuleBoard.module.css";

export interface NSModuleBoardSectionItemProps
{
    title: string;
    hint?: string;
    href: string;
    icon: ReactNode;
}

export interface NSModuleBoardSectionProps
{
    title: string;
    accentFrom: string;
    accentTo: string;
    iconBg: string;
    iconColor: string;
    items: NSModuleBoardSectionItemProps[];
}

export interface NSModuleBoardProps
{
    sections: NSModuleBoardSectionProps[];
}

const arrowIcon = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
        <path d="M5 12h14M13 6l6 6-6 6" />
    </svg>
);

export function NSModuleBoard(props: NSModuleBoardProps)
{
    return (
        <div className={Styles.board}>
            {props.sections.map(section =>
            {
                const sectionStyle = {
                    "--ns-accent-from": section.accentFrom,
                    "--ns-accent-to": section.accentTo,
                    "--ns-icon-bg": section.iconBg,
                    "--ns-icon-color": section.iconColor,
                } as CSSProperties;

                return (
                    <div key={section.title} className={Styles.section} style={sectionStyle}>
                        <div className={Styles.header}>
                            <span className={Styles.accent} />
                            <div className={Styles.title}>{section.title}</div>
                            <span className={Styles.count}>{section.items.length}</span>
                        </div>
                        <div className={Styles.grid}>
                            {section.items.map(item => (
                                <a key={item.title} href={item.href} className={Styles.card}>
                                    <span className={Styles.cardIcon}>{item.icon}</span>
                                    <span className={Styles.cardText}>
                                        <span className={Styles.cardTitle}>{item.title}</span>
                                        {item.hint && <span className={Styles.cardHint}>{item.hint}</span>}
                                    </span>
                                    <span className={Styles.cardArrow}>{arrowIcon}</span>
                                </a>
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}